"use client";

import { useEffect, useLayoutEffect } from "react";
import { THEME_ZONE_ATTR, applyTheme, syncTheme } from "@/lib/theme";

const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;

/**
 * Marks the page it is rendered on as light only (the app behind sign-in and
 * the auth screens have no dark styles). The pre-paint script already keeps a
 * full page load of these routes light; this covers arriving by client-side
 * navigation, and hands the visitor's preference back when they leave.
 * Layout effects, so neither switch is ever painted in the wrong theme.
 */
export default function LightOnlyTheme() {
  useIsomorphicLayoutEffect(() => {
    const root = document.documentElement;
    root.setAttribute(THEME_ZONE_ATTR, "light");
    applyTheme(false);
    return () => {
      root.removeAttribute(THEME_ZONE_ATTR);
      syncTheme();
    };
  }, []);
  return null;
}
